(function () {
  var section = document.querySelector('[data-section-type="cards-buy"]');
  if (!section) return;

  var sid               = section.dataset.sectionId;
  var minCards          = parseInt(section.dataset.minCards, 10)        || 0;
  var shippingThreshold = parseFloat(section.dataset.shippingThreshold) || 60;
  var shippingFee       = parseFloat(section.dataset.shippingFee)       || 5;
  var gramsPerCard      = parseFloat(section.dataset.gramsPerCard)      || 2;
  var cardsPerKg        = 1000 / gramsPerCard;
  var form              = section.querySelector('form');
  if (!form) return;

  function el(id) { return document.getElementById(id + '-' + sid); }

  // ── hCaptcha ──────────────────────────────────────────────────────────────
  if (window.Shopify && window.Shopify.captcha) {
    window.Shopify.captcha.protect(form);
  }

  // ── Zahlungsmethode Toggle ────────────────────────────────────────────────
  var paymentSelect = el('cb-payment');
  var paypalWrapper = el('cb-paypal');
  var ibanWrapper   = el('cb-iban');
  var paypalInput   = el('cb-paypal-account');
  var ibanInput     = el('cb-iban-input');

  if (paymentSelect) {
    paymentSelect.addEventListener('change', function () {
      var isPayPal = this.value === 'paypal';
      var isBank   = this.value === 'bank';
      paypalWrapper.style.display = isPayPal ? 'block' : 'none';
      ibanWrapper.style.display   = isBank   ? 'block' : 'none';
      paypalInput.required        = isPayPal;
      ibanInput.required          = isBank;
    });
  }

  // ── Rechner ───────────────────────────────────────────────────────────────
  function parsePriceStr(str) {
    return parseFloat((str + '').replace(',', '.')) || 0;
  }

  function formatEuro(val) {
    var parts = val.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return parts.join(',') + ' \u20AC';
  }

  // Trimmt \u00FCberfl\u00FCssige Nachkommastellen (2.000 -> "2", 1.500 -> "1,5")
  function formatKg(val) {
    var str = val.toFixed(3).replace(/0+$/, '').replace(/\.$/, '');
    if (str === '' || str === '-0') str = '0';
    return str.replace('.', ',');
  }

  function calculate() {
    var total    = 0;
    var stkQty   = 0; // Summe der St\u00FCck-basierten Kategorien
    var weightKg = 0; // Summe der Gewichts-basierten Kategorien (kg)

    section.querySelectorAll('.cb-qty').forEach(function (input) {
      var unit   = input.dataset.unit || 'stk';
      var qty    = unit === 'kg' ? (parseFloat(input.value) || 0) : (parseInt(input.value, 10) || 0);
      var price  = parsePriceStr(input.dataset.price);
      var amount = qty * price;

      var blockId = input.id
        .replace('qty-', '')
        .replace('-' + sid, '');

      var ltEl  = document.getElementById('lt-'  + blockId + '-' + sid);
      var hidEl = document.getElementById('hid-' + blockId + '-' + sid);

      if (ltEl)  ltEl.textContent = formatEuro(amount);
      if (hidEl) hidEl.value = qty > 0
        ? (unit === 'kg' ? formatKg(qty) + ' kg = ' + formatEuro(amount) : qty + ' St\u00FCck = ' + formatEuro(amount))
        : '';

      total += amount;
      if (unit === 'kg') {
        weightKg += qty;
      } else {
        stkQty += qty;
      }
    });

    var totalQty = stkQty + (weightKg * cardsPerKg); // Karten\u00E4quivalent f\u00FCr den Mindestmengen-Check

    // Bonus
    var baseTotal = total + (bonusApplied ? bonusAmount : 0);

    // Versand
    var freeShipping = baseTotal >= shippingThreshold;
    var shippingCost = (total > 0 && !freeShipping) ? shippingFee : 0;
    var displayTotal = baseTotal - shippingCost;

    // Versandhinweis
    var shippingNotice = el('cb-shipping-notice');
    var shippingText   = el('cb-shipping-text');
    var shippingLine   = el('cb-shipping-line');
    var shippingAmtEl  = el('cb-shipping-amount');
    var hidShipping    = el('cb-hidden-shipping');

    if (total > 0) {
      if (shippingNotice) shippingNotice.style.display = 'block';
      if (freeShipping) {
        if (shippingText) shippingText.textContent =
          '\u2705 Versandkostenfrei \u2013 wir senden dir nach Pr\u00FCfung ein kostenloses Versandlabel zu.';
        if (shippingLine) shippingLine.style.display = 'none';
        if (hidShipping)  hidShipping.value = 'Versandkostenfrei';
      } else {
        var missing = shippingThreshold - baseTotal;
        if (shippingText) shippingText.textContent =
          '\uD83D\uDCE6 Versandpauschale ' + formatEuro(shippingFee) +
          ' wird vom Auszahlungsbetrag abgezogen. Noch ' +
          formatEuro(missing) + ' bis zum kostenlosen Versand.';
        if (shippingLine)  shippingLine.style.display  = 'block';
        if (shippingAmtEl) shippingAmtEl.textContent   = '\u2212 ' + formatEuro(shippingFee);
        if (hidShipping)   hidShipping.value = 'Versandpauschale \u2212 ' + formatEuro(shippingFee);
      }
    } else {
      if (shippingNotice) shippingNotice.style.display = 'none';
      if (shippingLine)   shippingLine.style.display   = 'none';
    }

    // Gesamtsumme & Counter
    var cardCountEl   = el('cb-card-count');
    var weightLine    = el('cb-weight-line');
    var weightCountEl = el('cb-weight-count');
    var totalEl       = el('cb-total');
    var hidTotalEl    = el('cb-hidden-total');
    var hidCountEl    = el('cb-hidden-count');
    var submitBtn     = el('cb-submit');
    var minNotice     = el('cb-min-notice');

    var totalCards = Math.round(totalQty); // Kartenäquivalent inkl. umgerechneter kg-Mengen

    if (cardCountEl)   cardCountEl.textContent   = stkQty.toLocaleString('de-DE') + ' Karten';
    if (weightLine)    weightLine.style.display  = weightKg > 0 ? 'block' : 'none';
    if (weightCountEl) weightCountEl.textContent = formatKg(weightKg) + ' kg';
    if (totalEl)       totalEl.textContent       = formatEuro(displayTotal);
    if (hidTotalEl)    hidTotalEl.value          = formatEuro(displayTotal);
    if (hidCountEl)    hidCountEl.value          = totalCards + ' Karten';

    var meetsMin = totalQty >= minCards;
    if (submitBtn)  submitBtn.disabled      = !meetsMin;
    if (minNotice)  minNotice.style.display = (!meetsMin && totalCards > 0) ? 'block' : 'none';
  }

  // Statischer Hinweis auf die Mindestmenge in kg (z.B. "1.000 Karten / 2 kg")
  var minWeightEl = el('cb-min-weight');
  if (minWeightEl && minCards > 0) {
    minWeightEl.textContent = ' / ' + formatKg(minCards / cardsPerKg) + ' kg';
  }

  section.querySelectorAll('.cb-qty').forEach(function (input) {
    input.addEventListener('input', calculate);
  });

  // ── Bonus-Code ────────────────────────────────────────────────────────────
  var bonusApplied  = false;
  var bonusAmount   = 5.00;
  var rawCodes      = (section.dataset.bonusCodes || '').trim();
  var validCodes    = rawCodes.length
    ? rawCodes.split(/\r?\n/).map(function (s) { return s.trim().toUpperCase(); }).filter(Boolean)
    : [];

  var codeInput  = document.getElementById('cb-code-input-'      + sid);
  var codeBtn    = document.getElementById('cb-code-btn-'         + sid);
  var codeReset  = document.getElementById('cb-code-reset-'       + sid);
  var codeMsg    = document.getElementById('cb-code-msg-'         + sid);
  var hiddenCode = document.getElementById('cb-hidden-code-used-' + sid);

  function showCodeMsg(text, isSuccess) {
    codeMsg.textContent   = text;
    codeMsg.className     = 'm-0 t5 cb-code-msg ' + (isSuccess ? 'cb-code-msg--success' : 'cb-code-msg--error');
    codeMsg.style.display = 'block';
  }

  function applyCode() {
    if (!codeInput || !validCodes.length) return;
    var entered = codeInput.value.trim().toUpperCase();

    if (bonusApplied) return;

    if (!entered) {
      showCodeMsg('Bitte einen Code eingeben.', false);
      return;
    }

    if (validCodes.indexOf(entered) !== -1) {
      bonusApplied           = true;
      if (hiddenCode) hiddenCode.value = codeInput.value.trim();
      codeInput.disabled     = true;
      codeBtn.style.display  = 'none';
      if (codeReset) codeReset.style.display = 'block';
      showCodeMsg('+5,00 \u20AC Bonus eingelöst! \u2713', true);
      calculate();
    } else {
      showCodeMsg('Code ungültig.', false);
    }
  }

  function resetCode() {
    bonusApplied           = false;
    codeInput.disabled     = false;
    codeInput.value        = '';
    if (hiddenCode) hiddenCode.value = '';
    codeBtn.style.display  = 'block';
    if (codeReset) codeReset.style.display = 'none';
    codeMsg.style.display  = 'none';
    calculate();
  }

  if (codeBtn)   codeBtn.addEventListener('click', applyCode);
  if (codeReset) codeReset.addEventListener('click', resetCode);
  if (codeInput) codeInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); applyCode(); }
  });

  // ── IBAN-Validierung ──────────────────────────────────────────────────────
  if (ibanInput) {
    ibanInput.addEventListener('input', function () {
      var clean = this.value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
      this.classList.toggle('field__input--error',
        this.value.length > 0 && !/^[A-Z]{2}[0-9]{2}[A-Z0-9]{4,30}$/.test(clean)
      );
    });
  }

  // ── Submit-Validierung ────────────────────────────────────────────────────
  form.addEventListener('submit', function (e) {
    var valid    = true;
    var email    = el('cb-email');
    var agb      = el('cb-agb');
    var totalQty = 0;

    section.querySelectorAll('.cb-qty').forEach(function (input) {
      var unit = input.dataset.unit || 'stk';
      var qty  = unit === 'kg' ? (parseFloat(input.value) || 0) : (parseInt(input.value, 10) || 0);
      totalQty += unit === 'kg' ? qty * cardsPerKg : qty;
    });

    // Mindestmenge
    if (totalQty < minCards) {
      e.preventDefault();
      return;
    }

    // E-Mail
    if (email && (!email.value.includes('@') || !email.value.includes('.'))) {
      email.classList.add('field__input--error');
      valid = false;
    }

    // IBAN
    if (ibanWrapper && ibanWrapper.style.display !== 'none' && ibanInput && ibanInput.value) {
      var clean = ibanInput.value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
      if (!/^[A-Z]{2}[0-9]{2}[A-Z0-9]{4,30}$/.test(clean)) {
        ibanInput.classList.add('field__input--error');
        valid = false;
      }
    }

    // AGB
    if (agb && !agb.checked) {
      agb.closest('.field__checkbox-wrapper').classList.add('cb-error-text');
      valid = false;
    }

    if (!valid) {
      e.preventDefault();
      alert('Bitte korrigiere die markierten Felder.');
    }
  });

  // AGB-Fehler zurücksetzen sobald angehakt
  var agbEl = el('cb-agb');
  if (agbEl) {
    agbEl.addEventListener('change', function () {
      if (this.checked) {
        this.closest('.field__checkbox-wrapper').classList.remove('cb-error-text');
      }
    });
  }

  // ── Tooltips: aus dem overflow-hidden-Container ausbrechen ────────────────
  // Die Kartentyp-Tabelle steckt in einem <details class="overflow-hidden">.
  // Der rein per CSS oberhalb des Ankers positionierte Tooltip wird dadurch
  // an der oberen/unteren Container-Kante abgeschnitten. Loesung: sobald der
  // Tooltip sichtbar wird, per JS auf position:fixed umstellen, am Anker
  // ausrichten und bei zu wenig Platz oben nach unten klappen.
  (function initTooltips() {
    var anchors = section.querySelectorAll('.cb-tooltip-anchor');
    if (!anchors.length) return;

    var GAP = 8;      // Abstand Tooltip <-> Anker
    var MARGIN = 8;   // Mindestabstand zum Viewport-Rand
    var openAnchor = null;

    function place(anchor) {
      var tip = anchor.querySelector('.cb-tooltip');
      if (!tip) return;
      openAnchor = anchor;
      anchor.classList.add('cb-open');
      tip.classList.add('cb-tooltip--floating');

      // Fuer die Messung kurz unsichtbar an den Ursprung setzen
      tip.style.visibility = 'hidden';
      tip.style.left = '0px';
      tip.style.top = '0px';

      var a = anchor.getBoundingClientRect();
      var t = tip.getBoundingClientRect();
      var vw = document.documentElement.clientWidth;
      var vh = document.documentElement.clientHeight;

      // Horizontal an der linken Anker-Kante ausrichten, in den Viewport klemmen
      var left = a.left;
      if (left + t.width > vw - MARGIN) left = vw - MARGIN - t.width;
      if (left < MARGIN) left = MARGIN;

      // Vertikal bevorzugt oberhalb; reicht der Platz nicht und unten ist mehr
      // Platz -> unterhalb klappen
      var spaceAbove = a.top;
      var spaceBelow = vh - a.bottom;
      var below = spaceAbove < t.height + GAP && spaceBelow > spaceAbove;

      var top;
      if (below) {
        top = a.bottom + GAP;
        tip.classList.add('cb-tooltip--below');
      } else {
        top = a.top - GAP - t.height;
        tip.classList.remove('cb-tooltip--below');
      }
      // Falls beidseitig zu wenig Platz: hart in den Viewport klemmen
      if (top < MARGIN) top = MARGIN;
      if (top + t.height > vh - MARGIN) top = vh - MARGIN - t.height;

      // Pfeil auf die Anker-Mitte ausrichten (Dreieck ist 12px breit)
      var arrowCenter = a.left + a.width / 2 - left;
      arrowCenter = Math.max(12, Math.min(t.width - 12, arrowCenter));
      tip.style.setProperty('--cb-arrow-x', (arrowCenter - 6) + 'px');

      tip.style.left = Math.round(left) + 'px';
      tip.style.top = Math.round(top) + 'px';
      tip.style.visibility = '';
    }

    function clear(anchor) {
      if (openAnchor === anchor) openAnchor = null;
      var tip = anchor.querySelector('.cb-tooltip');
      anchor.classList.remove('cb-open');
      if (!tip) return;
      tip.classList.remove('cb-tooltip--floating', 'cb-tooltip--below');
      tip.style.left = '';
      tip.style.top = '';
      tip.style.visibility = '';
      tip.style.removeProperty('--cb-arrow-x');
    }

    anchors.forEach(function (anchor) {
      anchor.addEventListener('mouseenter', function () { place(anchor); });
      anchor.addEventListener('mouseleave', function () { clear(anchor); });
      anchor.addEventListener('focusin', function () { place(anchor); });
      anchor.addEventListener('focusout', function () { clear(anchor); });
    });

    // Offenen Tooltip bei Scroll/Resize mitfuehren
    function reflow() { if (openAnchor) place(openAnchor); }
    window.addEventListener('scroll', reflow, true);
    window.addEventListener('resize', reflow);
  })();

  calculate();
})();
